<template>
	<div class="login">
		<div class="neir cle">
			<img src="/static/img/login_beijing.jpg" class="img" alt="">
			<!-- <img src="/static/img/erweim.png" class="erweim" alt=""> -->
			<el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="top" label-width="0px" class="form">
				<div class="p1">樱桃种质云</div>
				<div class="p2">登录</div>
				<el-form-item label="请输入用户名" prop="username">
		    		<el-input type="text" v-model="ruleForm2.username" @keyup.enter.native="submitForm" auto-complete="off" placeholder=""></el-input>
		    	</el-form-item>
				<el-form-item label="请输入密码" prop="password">
		    		<el-input type="password" v-model="ruleForm2.password" @keyup.enter.native="submitForm" auto-complete="off" placeholder=""></el-input>
		    	</el-form-item>
				<el-form-item label="验证码" prop="captcha">
		    		<el-input type="text" class="yanzhengma_input" v-model="ruleForm2.captcha" @keyup.enter.native="submitForm" auto-complete="off" placeholder="">
						<img :src="captcha" class="yanzhengma" title="点击换一张" @click="get_captcha" slot="append" alt="">
		    		</el-input>
		    	</el-form-item>
				<div class="dengl" @click="submitForm">立即登录</div>
				<!-- <div class="dengl" @click="ceshi">测试</div> -->
			</el-form>
		</div>
		<div class="copyright">Copyright © 大连市现代农业生产发展服务中心（大连市农业科学研究院、大连市植物保护中心） All Rights Reserved.</div>
		<div class="yincang">
			<canvas type="2d" ref="myCanvas" id="myCanvas" canvas-id="myCanvas" class="canvas_share"></canvas>
		</div>
	</div>
</template>
<script>
var canvas,ctx;
export default {
	name:'',
	data() {
		const validatorCaptcha = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入验证码'));
			} else {
				if (value.toLowerCase()==this.captcha_text) {
					callback();
				} else {
					return callback(new Error('验证码错误'));
					this.get_captcha();
				}
			}
		};
		return {
			logining: false,
			ruleForm2: {
				username: '',
				captcha: '',
				password: ''
			},
			rules2: {
				username: [{
					required: true,
					message: '请输入账号',
					trigger: 'blur'
				}, ],
				password: [{
					required: true,
					message: '请输入密码',
					trigger: 'blur'
				}, ],
				captcha: [{
					required: true,
					validator: validatorCaptcha,
					trigger: 'blur'
				} ]
			},
			checked: true,
			captcha:'',
			captcha_text:'',
		};
	},
	// 初始事件
	mounted: function () {
		canvas = this.$refs.myCanvas;
		ctx = canvas.getContext('2d');
		canvas.width=200;
		canvas.height=100;
		this.get_captcha();
	},
	methods: {
		submitForm() {
			var _this = this;
			this.$refs.ruleForm2.validate((valid) => {
				if (valid) {
					var datas = {
						user_name: this.ruleForm2.username,
						password: this.ruleForm2.password
					};
					var url = "login";
					this.$post(url, datas).then(res => {
						sessionStorage.setItem('TokenId', res.TokenId);
						sessionStorage.setItem('user_name', res.user_name);
						sessionStorage.setItem('user_type', res.user_type);
						_this.$router.push({
							path: '/list_index'
						});
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 生成验证码图片
		get_captcha(){
			ctx.fillStyle = this.randomColor(200, 255); //颜色若太深可能导致看不清
	        ctx.fillRect(0, 0, 200, 100);
	        var text = '';
	        var str = 'abcefghjkmnpqrstwxyABCEFGHJKMNPQRSTWXY23456789';
	        for (var i = 0; i < 4; i++) {
		        var txt = str[this.randomNum(0, str.length)];
		        ctx.fillStyle = this.randomColor(50, 160); //随机生成字体颜色
		        ctx.font = this.randomNum(50, 50) + 'px SimHei'; //随机生成字体大小
		        var x = 5 + i * 50;
		        var y = this.randomNum(30, 70);
		        var deg = this.randomNum(-20, 20);
		        //修改坐标原点和旋转角度
		        ctx.translate(x, y);
		        ctx.rotate(deg * Math.PI / 180);
		        ctx.fillText(txt, 5, 0);
		        text = text + txt;
		        //恢复坐标原点和旋转角度
		        ctx.rotate(-deg * Math.PI / 180);
		        ctx.translate(-x, -y);
	        }
	        this.captcha_text=text.toLowerCase();
		    this.captcha = canvas.toDataURL('image/png');
		},
	    randomNum(min, max) {
	        return Math.floor(Math.random() * (max - min) + min);
	   	},
	    /**生成一个随机色**/
	    randomColor(min, max) {
	        let r = this.randomNum(min, max);
	        let g = this.randomNum(min, max);
	        let b = this.randomNum(min, max);
	        return "rgb(" + r + "," + g + "," + b + ")";
	    },
		ceshi(){
			var this_ = this;
			var url = "login/send_email_code";
			var datas = {
				email:'979766664@qq.com'
			}
			this_.$post(url, datas,true).then((res) => {
				
			});
		},
	}
}
</script>
<style scoped>
.login{
	background-color: #fff;
	width: 100%;
	height: 100vh;
	position: relative;
}
.login .copyright{
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	background-color: #367f4a;
	font-size: 18px;
	color: #ffffff;
	line-height: 60px;
	text-align: center;
}
.login .neir{
	position: absolute;
	left: 50%;
	top: 46%;
	width: 1040px;
	height: 680px;
	margin-left: -520px;
	margin-top: -340px;
}
.login .neir .erweim{
	position: absolute;
	left: 420px;
    top: 480px;
    width: 133px;
	z-index: 2;
}
.login .neir .img{
	position: absolute;
	left: 0;
	top: 50%;
	box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2); 
	height: 580px;
	margin-top: -290px;
	z-index: 2;
}
.login .neir .form{
	position: relative;
	z-index: 3;
	background-color: #ffffff;
	float: right;
	width: 470px;
	height: 100%;
	box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
	padding: 50px 80px 0 85px;
}
.login .neir .form .p1{
	font-size: 24px;
	color: #367f4a;
	font-weight: bold;
	text-align: center;
	margin-bottom: 90px;
}
.login .neir .form .p2{
	font-size: 30px;
	color: #367f4a;
	font-weight: bold;
	margin-bottom: 40px;
}
.login .neir .form .dengl{
	font-size: 20px;
	color: #ffffff;
	font-weight: bold;
	background-color: #367f4a;
	width: 150px;
	line-height: 42px;
	text-align: center;
	border-radius: 10px;
	height: 44px;
	cursor: pointer;
}
</style>
<style type="text/css">
.login .neir .form .el-form-item{
	margin-bottom: 30px;
}
.login .neir .form .el-form-item__label{
	font-size: 14px;
	line-height: 26px;
	padding-bottom: 0;
}	
.yincang{
	position: absolute;
	left: 0;
	top: 0;
	z-index: 1;
	width: 0px;
	height: 0px;
	overflow: hidden;
}
.yincang .canvas_share{
	width: 200px;
	height: 100px;
}
.yanzhengma_input .el-input-group__append{
	padding: 0;
}
.yanzhengma_input .el-input-group__append img{
	height:38px;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue